function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "customer-grid-pattern_svg__a",
  d: "M0 0h265v477H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.45
}, /*#__PURE__*/React.createElement("mask", {
  id: "customer-grid-pattern_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#customer-grid-pattern_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#36A97B",
  strokeLinecap: "square",
  mask: "url(#customer-grid-pattern_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M479 358.5h-602m602 41h-602m602 40h-602m602-242h-602m602 40h-602m602 41h-602m602 40h-602m602-282h-602m602 40h-602m602 41h-602m602 40h-602m281 321v-602m-40 602v-602m-41 602v-602m-40 602v-602m201 602v-602m-40 602v-602"
})));

function SvgCustomerGridPattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 265,
    height: 477
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjY1IiBoZWlnaHQ9IjQ3NyI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0wIDBoMjY1djQ3N0gweiIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIG9wYWNpdHk9Ii40NSI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PGcgc3Ryb2tlPSIjMzZBOTdCIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBtYXNrPSJ1cmwoI2IpIj48cGF0aCBkPSJNNDc5IDM1OC41aC02MDJNNDc5IDM5OS41aC02MDJNNDc5IDQzOS41aC02MDJNNDc5IDE5Ny41aC02MDJNNDc5IDIzNy41aC02MDJNNDc5IDI3OC41aC02MDJNNDc5IDMxOC41aC02MDJNNDc5IDM2LjVoLTYwMk00NzkgNzYuNWgtNjAyTTQ3OSAxMTcuNWgtNjAyTTQ3OSAxNTcuNWgtNjAyTTE1OCA0NzguNXYtNjAyTTExOCA0NzguNXYtNjAyTTc3IDQ3OC41di02MDJNMzcgNDc4LjV2LTYwMk0yMzggNDc4LjV2LTYwMk0xOTggNDc4LjV2LTYwMiIvPjwvZz48L2c+PC9zdmc+";
export { SvgCustomerGridPattern as ReactComponent };